import { render, staticRenderFns } from "./CreateUserBetgame.vue?vue&type=template&id=490d7b3c&scoped=true"
import script from "./CreateUserBetgame.vue?vue&type=script&lang=js"
export * from "./CreateUserBetgame.vue?vue&type=script&lang=js"
import style0 from "./CreateUserBetgame.vue?vue&type=style&index=0&id=490d7b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d7b3c",
  null
  
)

export default component.exports